// Нарушения за текущий месяц в списке активных (RD-153-B-r4).
// Источник — готовое results[].violations_count строки GET /api/user/: ожидаемое дополнение RD-154,
// считается backend по правилу discipline RD-161 (totals.violations_count) по всем доступным ТУ.
// Фронт ничего не досчитывает: ни из month_schedule, ни запросами discipline, ни моками.

// null — поля нет либо значение не целое неотрицательное число: показывается «—», не 0.
export const readViolationsCount = (value: unknown): number | null =>
    typeof value === 'number' && Number.isInteger(value) && value >= 0 ? value : null
